import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CandidateService } from 'src/app/services/candidate.service';
import { LoaderServiceService } from 'src/app/services/loader-service.service';

@Component({
  selector: 'app-cancellation-policy',
  templateUrl: './cancellation-policy.component.html',
  styleUrl: './cancellation-policy.component.scss'
})
export class CancellationPolicyComponent {
  tncData: any = {}
  constructor(
    private router: Router,
    private candidateService: CandidateService,
    private loaderService: LoaderServiceService,


  ) {
    this.scrollToTop()
  }
  scrollToTop() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }

  ngOnInit() {
    this.getPolicyByName('cancellation_policy');
  }
  getPolicyByName(name: any) {
    this.loaderService.show();

    let reqObj = {
      name: name,
    };
    this.candidateService.getPolicyByName(reqObj).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.loaderService.hide();

        // this.blogList=response.data
        this.tncData = response.data


      }
    });
  }
  //   constructor(private router:Router){
  //     this.scrollToTop()
  //   }
  //   scrollToTop() {
  //     document.documentElement.scrollTop = 0;
  //     document.body.scrollTop = 0;
  //   }
  goTo(link: any) {
    this.router.navigate([link])
  }
}
